//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//

import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import Label from "eai-configurator-ui/components/base/Label";
import * as wijmo from "@grapecity/wijmo";
import "@grapecity/wijmo.styles/wijmo.css";
import "src/components/auditor/wijmo.css";
import * as Config from "eai-configurator-ui/components/configuration/utils/ConfigurationRegistry";
import AuditorReportTable from "src/components/auditor/table/AuditorReportTable";
import * as wjChart from "@grapecity/wijmo.react.chart";

const useStyles = makeStyles((theme) => ({
    button: {
        margin: "3px",
    },
    grid: {
        position: "relative",
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#00A994",
        position: "absolute",
        backgroundColor: "rgba(255,255, 255, 0.5)",
    },
    columnPickerIcon: {
        cursor: "pointer",
        color: "#FF8754",
        margin: "3px",
    },
    columnPickerDiv: {
        display: "none",
    },
    columnPicker: {
        /* IE fallback */
        padding: "12px",
        marginLeft: "12px",
        marginTop: "26px",
        boxShadow: "0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)",
    },
    paper: {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        maxHeight: "300px",
        overflow: "auto",
        height: "100%",
    },
}));

const AuditorUserActivityTablePage = ({path, appSettings, selectedEntity}) => {
    const [renderCounter, setRenderCounter] = React.useState(0);
    const [selectedEpsNodes, setSelectedEpsNodes] = React.useState(null);
    const [selectedObjectIds, setSelectedObjectIds] = React.useState(null);
    const [metadataChangeCounter, setMetadataChangeCounter] = React.useState(0);
    const [chart, setChart] = React.useState(null);
    const [chartData, setChartData] = React.useState(null);

    const classes = useStyles();

    const chartInitialized = (flex) => {
        setChart(flex);
    };

    const handleMetadataChanged = () => {
        setMetadataChangeCounter(metadataChangeCounter + 1);
    };

    // let sum = chartData.map((c) => c.sales).reduce((sum, cur) => sum + cur);
    const title = selectedEntity.displayName + " - User Report"

    return (
        <React.Fragment>
            <Label title={title}/>
            <AuditorReportTable
                key={selectedEntity.key + metadataChangeCounter}
                path={path}
                entityName={selectedEntity.key}
                epsNodes={selectedEpsNodes}
                objectIds={selectedObjectIds}
                onMetadataChanged={handleMetadataChanged}
                updateColumnsOnPageChange={false}
                refreshVisible={true}
                reloadColumnsVisible={true}
                refreshDataAlways={true}
                appSettings={appSettings}
                reloadColumnsAutomatically={false}
            />
            {chartData && (
                <div className="container-fluid">
                    <wjChart.FlexPie
                        header="Logins Last 30 Days"
                        bindingName="Actual Name"
                        binding="Logins Last 30 Days"
                        itemsSource={chartData}
                        initialized={chartInitialized}
                    >
                        <wjChart.FlexPieDataLabel
                            content={(ht) => {
                                return wijmo.format("{name} {val}", {
                                    name: ht.name,
                                    val: ht.value,
                                });
                            }}
                        />
                    </wjChart.FlexPie>
                </div>
            )}
        </React.Fragment>
    );
};
export default AuditorUserActivityTablePage;
